import { render, staticRenderFns } from "./EnvironmentalSection.vue?vue&type=template&id=89043b48&scoped=true&"
import script from "./EnvironmentalSection.vue?vue&type=script&lang=js&"
export * from "./EnvironmentalSection.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentModule.css?vue&type=style&index=0&id=89043b48&scoped=true&lang=css&"
import style1 from "../../sass/components/continue-section.css?vue&type=style&index=1&id=89043b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89043b48",
  null
  
)

export default component.exports